import gsap from 'gsap/all';
import { TextPlugin } from 'gsap/all';
import Component from '../core/Component';
// import AutocompleteData from './CompaniesSearchData.json';

gsap.registerPlugin(TextPlugin);

export default class CompaniesSearch extends Component {
    tl = null;

    constructor(element) {
        super(element);

        this.ref = {
            searchInput: null,
            searchClear: null,
            searchList:  null,
            searchItems: [],
            results:     [],
            timeline:    null,
            map:         null,
            mapMarker:   null,
            fakeData:    null
        };
    }

    prepare() {
        this.setInitialState();
        this.setupInput();
        this.setupResults();
        this.setupTimeline();
        this.setupMap();
        this.tl.play();
    }

    setInitialState() {
        this.tl = gsap.timeline({
            repeat:      -1,
            repeatDelay: 3
        }).to(
            [
                this.ref.results,
                this.ref.timeline,
                this.ref.map,
                this.ref.mapMarker,
            ],
            {
                opacity: 0,
                onStart: () => {
                    this.ref.searchInput.classList.add('placeholder');
                    this.ref.searchList.classList.remove('show');
                    this.ref.searchClear.classList.remove('visible');
                    this.ref.searchList.children[0].querySelector('a').classList.remove('click-efect');
                }
            }
        ).to(
            this.ref.mapMarker,
            {
                y: '-30px'
            }
        ).to(
            this.ref.results,
            {
                duration: 0,
                y:        '+10px'
            }
        );
    }

    setupInput() {
        this.tl.to(
            this.ref.searchInput,
            {
                text:       '',
                ease:       'none',
                duration:   0,
                onComplete: () => {
                    this.ref.searchInput.classList.remove('placeholder');
                }
            }
        ).to(
            this.ref.searchInput,
            {
                text:     'ava',
                duration: 1,
                ease:     'none',
                onUpdate: () => {
                    this.updateList();
                    this.ref.searchClear.classList.add('visible');
                    this.ref.searchList.classList.add('show');
                }
            }
        ).to(this.ref.searchList.children[0], {
            duration:   .2,
            onComplete: () => {
                this.ref.searchList.children[0].querySelector('a').classList.add('click-efect');
            }
        }).to(this.ref.searchList, {
            delay:      .3,
            onComplete: () => {
                this.ref.searchInput.textContent = 'AVANTRO s.r.o.';
                this.ref.searchList.classList.remove('show');
            }
        });
    }

    setupResults() {
        this.tl.to(
            this.ref.results,
            {
                opacity:  1,
                duration: .3,
                delay:    .2,
                y:        0,
                stagger:  {
                    each: 0.1
                }
            }
        );
    }

    setupTimeline() {
        this.tl.to(
            this.ref.timeline,
            {
                opacity:  1,
                duration: .5,
                delay:    .1
            }
        );
    }

    setupMap() {
        this.tl.to(
            this.ref.map,
            {
                opacity: 1,
                delay:   .1
            }
        ).to(
            this.ref.mapMarker,
            {
                opacity:  1,
                duration: .3,
                delay:    .1,
                y:        0
            }
        );
    }

    updateList() {
        const text = this.ref.searchInput.textContent;
        if (text.length < 1 || text.length > 3) {
            return;
        }

        // const data = AutocompleteData[text.length];

        if (this.ref.fakeData === null) {
            return;
        }

        let fakeData = this.ref.fakeData.dataset.fakeData;
        fakeData = JSON.parse(fakeData);

        if (!fakeData[text.length]) {
            return;
        }

        const data = fakeData[text.length];

        this.ref.searchItems.forEach((item, i) => {
            const matches = data[i].name.match(new RegExp('^(' + text + ')(.*)', 'i'));
            item.querySelector('.name').innerHTML = data[i].name.replace(matches[1], '<span class="selected">' + matches[1] + '</span>');

            // const nameText = item.querySelector('.name').innerText
            // const matches  = nameText.match(new RegExp("^("+ text +")(.*)", "i"));
            //
            // item.querySelector('.name').innerHTML = nameText.replace(matches[1], '<span class="selected">' + matches[1] + '</span>')
            //
            // console.log(item.querySelector('.name').innerText);
        });
    }
}
